<div class="growerProgramNameDialog">
  <div class="row dialogHeader">
    <h2>Select A Program</h2>
  </div>
  <div class="row">
    <div class="col-12 margin-t10">
      <div class="productTableOuter">
        <div class="tableContainer prodTableContainer">
          <table mat-table [dataSource]="programDataSource" multiTemplateDataRows class="matTables productTable">
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="column === 'rowNumber'"></ng-container>
                <ng-container *ngIf="column === 'programName'">Program Name</ng-container>
                <ng-container *ngIf="column === 'cropYear'">Crop Year</ng-container>
                <ng-container *ngIf="column === 'programType'">Program Type</ng-container>
                <ng-container *ngIf="column === 'budgetType'">Budget Type</ng-container>
                <ng-container *ngIf="column === 'approval'">Local Approval</ng-container>
                <ng-container *ngIf="column === 'productLine'">Product Line</ng-container>
                <ng-container *ngIf="column === 'EnrollmentStart'">Enrollment Start</ng-container>
                <ng-container *ngIf="column === 'EnrollmentEnd'">Enrollment End</ng-container>
                <ng-container *ngIf="column === 'HybridVarietyTypes'">Hybrid Variety Types</ng-container>
              </th>
              <td mat-cell *matCellDef="let element;let i = dataIndex" (click)="selectRow(element)" [ngClass]="{'highlightRow': selectedRowId == element.id}">
                <ng-container *ngIf="column === 'checkbox'">
                  <div class="col-12 material-select">
                    <mat-checkbox #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                  [(ngModel)]="element.isSelected"
                                  class="custom-checkbox"></mat-checkbox>
                  </div>
                </ng-container>
                <ng-container *ngIf="column === 'rowNumber'" class="text-left">
                  <p>{{ i + 1 }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'programName'" class="text-left">
                  <p>{{ element.value }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'cropYear'" class="text-left">
                  <p>{{ element.cropYear }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'programType'" class="text-left">
                  <p>{{ element.programTypeName }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'budgetType'" class="text-left">
                  <p>{{ element.budgetTypeName }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'approval' && element.approval" class="text-left">
                  <p class="text-center">Yes</p>
                </ng-container>
                <ng-container *ngIf="column === 'approval' && !element.approval" class="text-left">
                  <p class="text-center">No</p>
                </ng-container>
                <ng-container *ngIf="column === 'productLine'" class="text-left">
                  <p>{{ element.productLineName }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'EnrollmentStart'" class="text-left">
                  <p>{{ element.enrollmentStartDate }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'EnrollmentEnd'" class="text-left">
                  <p>{{ element.enrollmentEndDate }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'HybridVarietyTypes'" class="text-left">
                  <p>{{ element.hybridVarietyTypes }}</p>
                </ng-container>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row add-order-sec margin-l0 margin-r0">
  <div class="col-12 padding-l25">
    <div class="row">
      <div class="col-6 padding-l25">
        <button mat-raised-button class="btns w180" [disabled]="!selectedElement" color="primary" (click)="selectProgram()">Select Program</button>
      </div>
      <div class="col-6 text-right m-auto padding-r30">
        <div>PROGRAM COUNT: {{programDataSource?.length}} </div>
      </div>
    </div>
  </div>
</div>
